module.exports = __webpack_public_path__ + "static/img_9753-c548ba811aa601279bc4d2e5baec50d0.webp";